import { Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useCountdown } from 'usehooks-ts'
import {
  connectionStatusView,
  isMultiTabView,
  loadedView,
  willReconnectInView,
  workspaceIdView,
} from '$comp/main/root.reducer'
import { t } from '$i18n'
import { useBrowserIsOnline } from '$hooks/use-browser-connection'
import { useEffect } from 'react'

export function useIsAppLoaded() {
  return useSelector(loadedView)
}

export function useIsMultiTab() {
  const isMultiTab = useSelector(isMultiTabView)
  return Boolean(isMultiTab)
}

export function useConnectionStatus() {
  return useSelector(connectionStatusView)
}

export function useWillReconnectIn() {
  return useSelector(willReconnectInView) as number
}

export function useDisplayedConnectionStatus() {
  const status = useConnectionStatus()
  const browserIsOnline = useBrowserIsOnline()
  const willReconnectIn = useWillReconnectIn()

  const [count, { startCountdown, stopCountdown, resetCountdown }] =
    useCountdown({
      countStart: willReconnectIn,
      intervalMs: 1000,
    })

  useEffect(() => {
    if (status !== 'will reconnect') stopCountdown()
  }, [status])

  useEffect(() => {
    if (willReconnectIn) {
      resetCountdown()
      startCountdown()
    }
  }, [willReconnectIn])

  if (status === 'connected') return null

  if (!browserIsOnline) return t('connectionStatus.waitingForNetwork')

  switch (status) {
    case 'connecting':
    case 'authenticating':
      // case 'will reconnect':
      return t('connectionStatus.connecting')
    case 'updating':
      return t('connectionStatus.updating')
    case 'will reconnect':
      return count ? (
        <Typography color="inherit" variant="subtitle2">
          {t('connectionStatus.willReconnect')(count)}
        </Typography>
      ) : (
        t('connectionStatus.connecting')
      )

    default:
      return null
  }
}

export function useCurrentWorkSpaceId() {
  return useSelector(workspaceIdView) as string
}
